import { Suspense } from "react";
import AdminTeamList from "../../components/admin/AdminTeamsList.jsx"
import { Link } from "react-router-dom";

export default function TeamListPage() {
  return (
    <section className="m-8">
      <div className="flex flex-row w-full">
        <h1 className="w-1/2">List of Teams</h1>
        <div className="w-1/2 text-end">
          <Link className="text-blue-500 underline hover:no-underline text-sm" to="/cocofantoelefanto/teams/new">Create New Team</Link>
        </div>
      </div>

      <div id="teams" className={`w-full pt-4'`}>
        <Suspense fallback={<p>Carregando...</p>}>
          <AdminTeamList />
        </Suspense>
      </div>
    </section>
  )
}
